function init() {
  if(use_klaviyo_btn){
    // Check initial state and apply appropriate styles
    const optionsList = document.querySelectorAll(".clickyboxes li a");
    let isUnavailable = false;

    const option = document.querySelector(".clickyboxes li a.active");
    if (option.classList.contains('unavailable')) {
      isUnavailable = true;
    }

    setBtnStyling(isUnavailable)

    // Add event listener to options
    optionsList.forEach(option => {
      option.addEventListener('click', handleOptionClick);
    });
  } 
}

const handleOptionClick = (e) => {
  const target = e.target;
  setBtnStyling(target.classList.contains('unavailable'))
};

function setBtnStyling(unavailable){
  const klaviyoButtonDesktop = document.querySelector('.klaviyo-bis-trigger.desktop');
  const klaviyoButtonSticky = document.querySelector('.klaviyo-bis-trigger.sticky');
  const mobileATCbtn = document.querySelector('.sticky-button-section .buttoxn-sticky');
  const quantityDisabledRow = document.querySelector('.quantity-submit-row__disabled');

  if (unavailable) {
    klaviyoButtonDesktop?.style.display = 'block';
    klaviyoButtonSticky?.style.display = 'block';
    quantityDisabledRow?.style.display = 'none';
    mobileATCbtn?.style.display = 'unset';
    mobileATCbtn?.style.display = 'none';
    mobileATCbtn?.classList.remove("d-flex");
  } else {
    klaviyoButtonDesktop?.style.display = 'none';
    klaviyoButtonSticky?.style.display = 'none';
    quantityDisabledRow?.style.display = 'block';
    mobileATCbtn?.style.display = 'block';
    mobileATCbtn?.classList.add("d-flex");
  }
}

document.addEventListener('load', init);
// Initialize the script when 'rendered-variants' event occurs
document.addEventListener('variants:rendered', init);

